/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {Color, IconProps, IconSize} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Full Screen Icon component.
 */
export const FullScreenIcon = ({color, size, ...props}: IconProps) => {
  const {iconSize, iconColor} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <path d='M5 15.5H2V23H9.5V20H5V15.5ZM2 9.5H5V5H9.5V2H2V9.5ZM20 20H15.5V23H23V15.5H20V20ZM15.5 2V5H20V9.5H23V2H15.5Z' fill={iconColor} />
    </svg>
  );
};
